function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Triangle");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Voyage-Overview",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.5
}, React.createElement("g", {
  id: "Qronoport---Berth-Overview-Copy",
  transform: "translate(-310.000000, -219.000000)",
  fill: "#06273A"
}, React.createElement("path", {
  d: "M313.157631,219.05174 L313.211917,219.094722 C313.21206,219.094865 313.212204,219.095009 313.212347,219.095152 L315.889907,221.778148 C316.006945,221.895424 316.006753,222.085373 315.889477,222.202412 C315.833233,222.258541 315.757019,222.290064 315.67756,222.290064 L310.32244,222.290064 C310.156755,222.290064 310.02244,222.15575 310.02244,221.990064 C310.02244,221.910605 310.053964,221.834391 310.110093,221.778148 L312.787653,219.095152 C312.887972,218.99463 313.041858,218.980128 313.157631,219.05174 Z",
  id: "Combined-Shape"
})));

var SvgSortableAscending = function SvgSortableAscending(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "6px",
    height: "4px",
    viewBox: "0 0 6 4",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSortableAscending, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sortable-ascending.215a438d.svg";
export { ForwardRef as ReactComponent };